import { Translate } from "@omni/types/utils/translate";
import * as yup from "yup";

import { OptionalBPostAddressValidationSchema } from "@/components/Form/RHF/FormFields/BPostAddressField/bpostAddressField.schema";
import { OptionalPhoneSchema } from "@/components/Form/RHF/FormFields/PhoneField/phoneField.schema";
import * as RHFAddressValidationRules from "@/utils/validation/schemas/address.RHF";
import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const WithdrawalFormSchema = yup
    .object({
        orderDate: yup.date().required(),
        orderNumber: yup.string().required(),
        orderDeliveryDate: yup
            .date()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .optional(),
        lastName: RHFUserValidationRules.lastName,
        firstName: RHFUserValidationRules.firstName,
        email: RHFUserValidationRules.emailWithNB,
        withdrawalProducts: yup.array().of(
            yup.object({
                value: yup.string().required()
            })
        ),
        withdrawalReason: yup.string().optional(),
        agreedToTermsAndConditions: yup
            .boolean()
            .required()
            .oneOf(
                [true],
                () => () => (t: Translate) =>
                    t(
                        "checkout.customerDetails.additionalServiceTermsOfService.validation.required"
                    )
            ),
        address: yup
            .object({
                country: RHFAddressValidationRules.country,
                street: RHFAddressValidationRules.optionalStreet,
                number: RHFAddressValidationRules.optionalNumber,
                box: RHFAddressValidationRules.optionalBox,
                zipCode: RHFAddressValidationRules.optionalZipCode,
                city: RHFAddressValidationRules.optionalCity,
                selected: RHFAddressValidationRules.selected,
                validationStatus:
                    RHFAddressValidationRules.validationStatus.optional(),
                isComplete: yup.boolean().optional()
            })
            .concat(OptionalBPostAddressValidationSchema)
    })
    .concat(OptionalPhoneSchema);

export type WithdrawalFormValues = yup.InferType<typeof WithdrawalFormSchema>;

export type WithdrawalFormInput = Omit<
    WithdrawalFormValues,
    "orderDeliveryDate" | "orderDate"
> & {
    orderDeliveryDate: Date | string;
    orderDate: Date | string;
};
